import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { adminApi } from "../../service/modules/admin";

const getInitialDates = (yearType) => {
    const now = moment();
    const endDate = now.format("DD-MM-YYYY");

    if (yearType === 'financial') {
        const currentMonth = now.month();
        // Create a new moment instance for start date to avoid mutating 'now'
        const startYear = currentMonth < 3 ? now.clone().subtract(1, "year") : now.clone();
        return {
            startDate: `01-04-${startYear.format("YYYY")}`,
            endDate
        };
    } else {
        return {
            startDate: `01-01-${now.format("YYYY")}`,
            endDate
        };
    }
};

// Default to calendar year dates until API responds
const initialState = getInitialDates('calendar');

const dateSlice = createSlice({
    name: "date",
    initialState,
    reducers: {
        setDate: (_, action) => {
            // Validate dates before setting them
            const startDate = moment(action.payload.startDate, "DD-MM-YYYY").isValid()
                ? action.payload.startDate
                : initialState.startDate;
            const endDate = moment(action.payload.endDate, "DD-MM-YYYY").isValid()
                ? action.payload.endDate
                : initialState.endDate;

            return { startDate, endDate };
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            adminApi.endpoints.getYearConfiguration.matchFulfilled,
            (state, { payload }) => {
                const dates = getInitialDates(payload.year_type);
                return dates;
            }
        );
    },
});

const { reducer, actions } = dateSlice;

export const { setDate } = actions;
export default reducer;
